import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=333299a1&scoped=true"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333299a1",
  null
  
)

export default component.exports